export default __webpack_public_path__ + "static/media/dklogo.fd242631.png";